import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationEaseIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAnimationEaseIn"><Path fillRule="evenodd" clipRule="evenodd" d="M21.1893 3.2349L20.9772 4.21214C19.9645 8.8776 18.1582 12.5767 15.3674 15.3675C12.5766 18.1583 8.87748 19.9646 4.21202 20.9773L3.23478 21.1894L2.81055 19.2349L3.78779 19.0228C8.1835 18.0687 11.501 16.4055 13.9532 13.9533C16.4054 11.5011 18.0686 8.18362 19.0227 3.78791L19.2348 2.81067L21.1893 3.2349Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnimationEaseIn;
